module.exports = __webpack_public_path__ + "static/media/ic-admin-btn-add-ticket.dc6fd5c3.svg";